/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const RulerDimensionLine = [
  ["path", { d: "M10 15v-3" }],
  ["path", { d: "M14 15v-3" }],
  ["path", { d: "M18 15v-3" }],
  ["path", { d: "M2 8V4" }],
  ["path", { d: "M22 6H2" }],
  ["path", { d: "M22 8V4" }],
  ["path", { d: "M6 15v-3" }],
  ["rect", { x: "2", y: "12", width: "20", height: "8", rx: "2" }]
];

export { RulerDimensionLine as default };
//# sourceMappingURL=ruler-dimension-line.js.map
